'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.eventSessionError = exports.eventVisitor = exports.eventSessionChange = exports.eventSessionInit = exports.eventUserChange = exports.eventLogout = exports.eventLogin = exports.eventStatusChange = exports.eventNotLoggedin = exports.subscribeEvents = exports.generateUrls = exports.logout = exports.hasProductError = exports.hasProductComplete = exports.hasAnyProduct = exports.hasProduct = exports.hasSessionError = exports.hasSessionComplete = exports.hasSession = exports.initComplete = exports.init = exports.start = undefined;

var _types = require('./types');

var start = exports.start = function start(config) {
    return {
        type: _types.SPID_START,
        payload: config
    };
};

var init = exports.init = function init(config) {
    return {
        type: _types.SPID_INIT,
        payload: config
    };
};

var initComplete = exports.initComplete = function initComplete(payload) {
    return {
        type: _types.SPID_INIT_COMPLETE,
        payload: payload
    };
};

var hasSession = exports.hasSession = function hasSession() {
    return {
        type: _types.SPID_HAS_SESSION
    };
};

var hasSessionComplete = exports.hasSessionComplete = function hasSessionComplete(data) {
    return {
        type: _types.SPID_HAS_SESSION_COMPLETE,
        payload: data
    };
};

var hasSessionError = exports.hasSessionError = function hasSessionError(data) {
    return {
        type: _types.SPID_HAS_SESSION_ERROR,
        payload: data
    };
};

var hasProduct = exports.hasProduct = function hasProduct(data) {
    return {
        type: _types.SPID_HAS_PRODUCT,
        payload: data
    };
};

var hasAnyProduct = exports.hasAnyProduct = function hasAnyProduct(data) {
    return {
        type: _types.SPID_HAS_ANY_PRODUCT,
        payload: data
    };
};

var hasProductComplete = exports.hasProductComplete = function hasProductComplete(data) {
    return {
        type: _types.SPID_HAS_PRODUCT_COMPLETE,
        payload: data
    };
};

var hasProductError = exports.hasProductError = function hasProductError(data) {
    return {
        type: _types.SPID_HAS_PRODUCT_ERROR,
        payload: data
    };
};

var logout = exports.logout = function logout(data) {
    return {
        type: _types.SPID_LOGOUT,
        payload: data
    };
};

var generateUrls = exports.generateUrls = function generateUrls(urls) {
    return {
        type: _types.SPID_GENERATE_URLS,
        payload: urls
    };
};

var subscribeEvents = exports.subscribeEvents = function subscribeEvents() {
    return {
        type: _types.SPID_SUBSCRIBE_EVENTS
    };
};

var eventNotLoggedin = exports.eventNotLoggedin = function eventNotLoggedin(data) {
    return {
        type: _types.SPID_EVENT_NOTLOGGEDIN,
        payload: data
    };
};

var eventStatusChange = exports.eventStatusChange = function eventStatusChange(data) {
    return {
        type: _types.SPID_EVENT_STATUS_CHANGE,
        payload: data
    };
};

var eventLogin = exports.eventLogin = function eventLogin(data) {
    return {
        type: _types.SPID_EVENT_LOGIN,
        payload: data
    };
};

var eventLogout = exports.eventLogout = function eventLogout(data) {
    return {
        type: _types.SPID_EVENT_LOGOUT,
        payload: data
    };
};

var eventUserChange = exports.eventUserChange = function eventUserChange(data) {
    return {
        type: _types.SPID_EVENT_USER_CHANGE,
        payload: data
    };
};

var eventSessionInit = exports.eventSessionInit = function eventSessionInit(data) {
    return {
        type: _types.SPID_EVENT_SESSION_INIT,
        payload: data
    };
};

var eventSessionChange = exports.eventSessionChange = function eventSessionChange(data) {
    return {
        type: _types.SPID_EVENT_SESSION_CHANGE,
        payload: data
    };
};

var eventVisitor = exports.eventVisitor = function eventVisitor(data) {
    return {
        type: _types.SPID_EVENT_VISITOR,
        payload: data
    };
};

var eventSessionError = exports.eventSessionError = function eventSessionError(data) {
    return {
        type: _types.SPID_EVENT_SESSION_ERROR,
        payload: data
    };
};
//# sourceMappingURL=actions.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-spid/lib/cjs/actions.js
 ** module id = 163
 ** module chunks = 0
 **/